"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var react_popper_tooltip_1 = __importDefault(require("react-popper-tooltip"));

require("./Tooltip.css");

function Tooltip(_a) {
  var Icon = _a.labelIcon,
      labelText = _a.labelText,
      ariaLabel = _a.ariaLabel,
      _b = _a.position,
      position = _b === void 0 ? "top" : _b,
      children = _a.children;
  var renderIconOrLabel = Icon ? React.createElement(Icon, null) : "" + labelText;

  function InternalTooltip(_a) {
    var arrowRef = _a.arrowRef,
        tooltipRef = _a.tooltipRef,
        getArrowProps = _a.getArrowProps,
        getTooltipProps = _a.getTooltipProps,
        placement = _a.placement;
    var tooltipProps = getTooltipProps({
      ref: tooltipRef,
      className: "nimbus--tooltip"
    });
    var arrowProps = getArrowProps({
      ref: arrowRef,
      className: "nimbus--tooltip__caret",
      "data-placement": placement
    });
    return React.createElement("div", __assign({}, tooltipProps, {
      role: "dialog"
    }), React.createElement("div", __assign({}, arrowProps)), children);
  }

  function Trigger(_a) {
    var getTriggerProps = _a.getTriggerProps,
        triggerRef = _a.triggerRef;
    var triggerProps = getTriggerProps({
      ref: triggerRef,
      className: "nimbus--tooltip-trigger"
    });
    return React.createElement("span", __assign({}, triggerProps, {
      role: "tooltip",
      "aria-label": ariaLabel || labelText
    }), renderIconOrLabel);
  }

  return React.createElement(react_popper_tooltip_1.default, {
    placement: position,
    trigger: ["hover", "click"],
    tooltip: InternalTooltip
  }, Trigger);
}

exports.default = Tooltip;